export default __webpack_public_path__ + "static/media/06_motor_Comunicacion.15326057.svg";